import React, { useEffect } from "react";
import styled from "styled-components";
import { Alert, util } from "@thecb/components";
import { useDispatch } from "react-redux";

const AlertBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AlertBar = ({
  alerts = [],
  deleteAlert = util.general.noop,
  clearAlerts = util.general.noop,
}) => {
  useEffect(() => () => clearAlerts(), [clearAlerts]);
  const dispatch = useDispatch();
  return (
    <AlertBarContainer>
      {alerts.map((alert, i) => (
        <Alert
          key={alert.heading}
          alertPosition={i}
          {...alert}
          text={
            alert.textWithDispatch ? alert.textWithDispatch(dispatch) : alert.text
          }
          onLinkClick={() => deleteAlert(i)}
        />
      ))}
    </AlertBarContainer>
  );
};

export default AlertBar;
